// Screenshot carousel in the "Try Forsyt for yourself" block (platform, index, benchmarkpro).
// Native scroll-snap does the sliding and swiping. Autoplay is driven by the
// active dot's CSS fill animation: when it ends, we move to the next slide, so
// pausing the animation (hover, focus, off-screen) also pauses autoplay.
const carousel = document.querySelector("[data-carousel]");

if (carousel) {
  const track = carousel.querySelector("[data-carousel-track]");
  const slides = [...track.children];
  const dotsWrap = carousel.querySelector("[data-carousel-dots]");
  let index = 0;

  const dots = slides.map((_, i) => {
    const dot = document.createElement("button");
    dot.type = "button";
    dot.className = "shot-dot";
    dot.setAttribute("aria-label", `Screenshot ${i + 1} of ${slides.length}`);
    dot.addEventListener("click", () => go(i));
    dot.addEventListener("animationend", () => go(index + 1));
    dotsWrap.append(dot);
    return dot;
  });

  const setActive = (i) => {
    index = i;
    dots.forEach((dot, j) => {
      dot.classList.toggle("is-active", j === i);
      dot.setAttribute("aria-current", j === i ? "true" : "false");
    });
  };

  const go = (i) => {
    const target = (i + slides.length) % slides.length;
    track.scrollTo({ left: slides[target].offsetLeft, behavior: "smooth" });
    setActive(target);
  };

  // Keep the dots in sync with manual swipes and keyboard scrolling.
  let scrollTimer;
  track.addEventListener("scroll", () => {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      const step = slides[1].offsetLeft - slides[0].offsetLeft;
      const i = Math.round(track.scrollLeft / step);
      if (i !== index) setActive(i);
    }, 120);
  });

  let hovered = false;
  let focused = false;
  let visible = false;
  const syncPause = () => carousel.classList.toggle("is-paused", hovered || focused || !visible);
  carousel.addEventListener("mouseenter", () => { hovered = true; syncPause(); });
  carousel.addEventListener("mouseleave", () => { hovered = false; syncPause(); });
  carousel.addEventListener("focusin", () => { focused = true; syncPause(); });
  carousel.addEventListener("focusout", () => { focused = false; syncPause(); });
  new IntersectionObserver(([entry]) => {
    visible = entry.isIntersecting;
    syncPause();
  }, { threshold: 0.4 }).observe(carousel);

  syncPause();
  setActive(0);
}
